module.exports = __webpack_public_path__ + "static/envelope-d5321740d48de8a597f1153d9545798d.svg";